module.exports = __webpack_public_path__ + "img/ics_o_plane-booking-black.9181da4e.svg";